export const SERVICE_TYPES = {
  Hemstädning: "Hemstädning",
  Flyttstädning: "Flyttstädning",
  Storstädning: "Storstädning",
  Kontorsstädning: "Kontorsstädning",
};
